export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const top = target.getBoundingClientRect().top + window.pageYOffset - 64;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20illustration%20with%20warm%20gradient%20background%20featuring%20abstract%20geometric%20shapes%20and%20flowing%20energy%20lines%2C%20deep%20red%20and%20orange%20tones%20merging%20with%20dark%20accents%2C%20cinematic%20composition%20with%20soft%20bokeh%20effects%2C%20professional%20anime%20key%20visual%20atmosphere%2C%20no%20characters&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-sm font-medium mb-5 whitespace-nowrap">
              2026夏季新番专题 — 全网最速更新
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
              51动漫网
              <span className="block text-xl md:text-2xl lg:text-3xl font-sans font-normal text-white/80 mt-2">
                日漫国漫高清资源下载中心
              </span>
            </h1>

            <p className="text-lg md:text-xl text-white/70 font-sans font-light leading-relaxed mb-4">
              海量动漫资源一站收录，免费高速下载无限制
            </p>

            <p className="text-sm md:text-base text-white/60 max-w-xl mx-auto lg:mx-0 leading-relaxed mb-8">
              51动漫网专注为动漫爱好者打造最全面的免费下载平台。覆盖日漫、国漫、韩漫全品类资源，支持全集下载与离线缓存。
              每日同步日本播出进度更新，热门新番24小时内极速上架。无论你是追番党还是补番党，这里都是你的动漫资源终点站。
              当前2026夏季新番专题已收录40+部新作，鬼灭之刃剧场版、咒术回战续作等年度重磅资源均已就绪。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">5,000+</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">收录作品</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-300">每日更新</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">50+部同步上架</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-400">安全纯净</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">无广告无捆绑</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => handleScrollTo(e, '#carousel')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-base whitespace-nowrap transition-all duration-200 cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                热门专题速览
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white border border-white/20 font-medium rounded-full text-base whitespace-nowrap transition-all duration-200 cursor-pointer"
              >
                <i className="ri-download-2-line text-lg"></i>
                查看下载排行
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[320px] md:max-w-[400px] lg:max-w-[420px]">
            <div className="relative aspect-[3/4] rounded-2xl overflow-hidden border border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20anime%20key%20visual%20illustration%20featuring%20a%20dynamic%20composition%20of%20popular%20anime%20characters%20in%20action%20poses%2C%20warm%20orange%20and%20crimson%20color%20palette%2C%20epic%20fantasy%20atmosphere%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20high%20quality%20anime%20art%20style%2C%20clean%20composition&width=840&height=1120&seq=hero-main&orientation=portrait"
                alt="51动漫网 — 热门动漫主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <span className="inline-block px-3 py-1 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                  2026夏季新番热映中
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}